/**
 * Updates Afterpay / Zip installment amounts when the product variant changes.
 */

function formatMoney(cents) {
  const amount = (Number(cents) / 100).toFixed(2);
  const template = window.theme?.settings?.moneyWithCurrencyFormat || '${{amount}}';

  // Prefer a simple $amount for installment labels matching Liquid | money.
  if (template.includes('{{amount}}') || template.includes('{{ amount }}')) {
    return template
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, amount)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, String(Math.round(Number(cents) / 100)))
      .replace(/\{\{\s*amount\s*\}\}/g, amount)
      .replace(/\s*NZD\s*/gi, '')
      .trim();
  }

  return `$${amount}`;
}

function updatePaymentOptions(variant) {
  if (!variant || typeof variant.price !== 'number') return;

  const containers = document.querySelectorAll('[data-product-payment-options]');
  if (!containers.length) return;

  const afterpayAmount = formatMoney(Math.floor(variant.price / 6));
  const zipAmount = formatMoney(Math.floor(variant.price / 4));

  containers.forEach((container) => {
    container.dataset.variantPrice = String(variant.price);

    const afterpayEl = container.querySelector('[data-product-price-afterpay]');
    if (afterpayEl) afterpayEl.textContent = afterpayAmount;

    const zipEl = container.querySelector('[data-product-price-zip]');
    if (zipEl) zipEl.textContent = zipAmount;
  });
}

export default function paymentOptions() {
  document.addEventListener('on:variant:change', (event) => {
    updatePaymentOptions(event.detail?.variant);
  });
}
